import React from "react";

import { classnames, Icon, PlainButton, Tooltip } from "@culturehq/components";

import slack from "images/slack.png";

import { t } from "app/utils";
import StoryCopyLink from "./StoryCopyLink";
import StoryShareUsers from "./StoryShareUsers";
import StoryShareSlack from "./StoryShareSlack";

import styles from "./styles.module.scss";

const PromptShareOptions = ({ organization, storyQuestion, parentPromptId }) => {
  const isStoryQuestionPausedStatus = storyQuestion.status === "paused";
  const isStoryQuestionArchivedStatus = storyQuestion.status === "archived";

  const isDisabled = isStoryQuestionPausedStatus || isStoryQuestionArchivedStatus;

  const handleTrigger = (e, onTrigger) => {
    e.stopPropagation();
    if (!isDisabled) onTrigger(e);
  };

  const getDisabledTooltipMessage = () => {
    if (isStoryQuestionPausedStatus) {
      return t("These options are disabled for paused prompts");
    }
    if (isStoryQuestionArchivedStatus) {
      return t("These options are disabled for archived prompts");
    }
    return null;
  };

  const disabledTooltipMessage = getDisabledTooltipMessage();

  const children = (
    <div className={classnames("PromptShareOptions__Buttons", { DisablePosition: isDisabled })}>
      <StoryCopyLink
        isPrompt={!storyQuestion.childStoryQuestions?.length}
        parentPromptId={parentPromptId}
        storyQuestion={storyQuestion}
      >
        {onTrigger => (
          <PlainButton
            aria-label="Share"
            className={classnames({ [styles["chq-pbn-disabled"]]: isDisabled })}
            onClick={e => handleTrigger(e, onTrigger)}
          >
            <Icon icon="link-wider-filled" />
          </PlainButton>
        )}
      </StoryCopyLink>
      <StoryShareUsers storyQuestion={storyQuestion}>
        {onTrigger => (
          <PlainButton
            className={classnames({ [styles["chq-pbn-disabled"]]: isDisabled })}
            onClick={e => handleTrigger(e, onTrigger)}
          >
            <Icon icon="send-filled" />
          </PlainButton>
        )}
      </StoryShareUsers>
      {organization.slackIntegration && (
        <StoryShareSlack storyQuestion={storyQuestion}>
          {onTrigger => (
            <PlainButton
              className={classnames({ [styles["chq-pbn-disabled"]]: isDisabled })}
              onClick={e => handleTrigger(e, onTrigger)}
            >
              <img className="Slack-Image" src={slack} alt="Slack" />
            </PlainButton>
          )}
        </StoryShareSlack>
      )}
    </div>
  );

  if (disabledTooltipMessage) {
    return (
      <div className="PromptShareDisabledTooltip">
        <Tooltip bottom tip={disabledTooltipMessage}>
          {children}
        </Tooltip>
      </div>
    );
  }

  return children;
};

export default PromptShareOptions;
